import * as R from 'ramda'
import * as ReactRouter from 'react-router-dom'
import * as Urql from 'urql'
import * as React from 'react'
import PropTypes from 'prop-types'

import * as Common from '@rushplay/common'

import { Clock } from './clock'

const getGame = `
  query Game($id: ID!) {
    game(id: $id) {
      displayProvider
      id
      provider
      title
    }
  }
`

export function GameWrapper(props) {
  const { gameId } = ReactRouter.useParams()

  const [response] = Urql.useQuery({
    query: getGame,
    variables: { id: gameId },
  })

  const game = R.pathOr({}, ['game'], response.data)

  return (
    <Common.Box
      flexGrow="1"
      flexShrink="1"
      flexBasis="0"
      display="flex"
      flexDirection="column"
    >
      <Common.Box
        display="flex"
        justifyContent={
          !response.fetching && !response.error ? 'space-between' : 'flex-end'
        }
        py={0}
        px={[0, 1]}
        backgroundColor="footer-background"
        borderBottom="1px solid"
        borderColor="rgba(250, 255, 255, 0.2)"
        fontSize={2}
      >
        {!response.fetching && !response.error && (
          <Common.Box
            as="h1"
            color="g-text"
            fontSize={1}
            opacity="0.5"
            display="flex"
            alignItems="center"
          >
            {`${game.title} - ${game.displayProvider || game.provider}`}
          </Common.Box>
        )}
        <Common.Box opacity="0.5">
          <Clock />
        </Common.Box>
      </Common.Box>
      {props.children}
    </Common.Box>
  )
}

GameWrapper.propTypes = {
  children: PropTypes.node,
  showModeSelector: PropTypes.bool,
}
